import apiClient from '../api/api'
import { LoginCredentials, LoginResponse, RefreshTokenResponse } from '@/interfaces/auth'
import { User } from '@/interfaces/user'

export const authApi = {
  // Get current user (call after login to get user info)
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/me')
    return response.data
  },

  // Login with email and password
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login', credentials)
    return response.data
  },

  // Login with JWT token (for testing)
  loginWithToken: async (token: string): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login-token', { token })
    return response.data
  },

  // Login with Google authorization code (PKCE)
  googleLogin: async (
    code: string,
    codeVerifier: string,
    redirectUri: string,
    state?: string
  ): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login-google', {
      code,
      codeVerifier,
      redirectUri,
      state,
    })
    return response.data
  },

  // Logout from Google (revokes access token)
  logoutGoogle: async (token: string): Promise<{ success: boolean }> => {
    const response = await apiClient.post<{ success: boolean }>('/auth/logout-google', {
      token,
    })
    return response.data
  },

  // Refresh access token using refresh token (also returns updated user profile)
  refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
    const response = await apiClient.post<RefreshTokenResponse>('/users/me', {
      refreshToken,
    })
    return response.data
  },
}
